import React from "react";
import { Navigate, useSearchParams } from "react-router-dom";

/**
 * Staff Portal → New Assessment.
 *
 * The create UX now lives as a MODAL DIALOG on the Assessments page
 * itself (visually mirrors the admin CreateAssessmentWizard modal).
 * This route stays for backwards-compatible deep links — it simply
 * bounces to `/staff-portal/assessments?compose=1[&student_id=...]`
 * which the list page reads on mount to auto-open the dialog.
 *
 * Direct-URL security continues to run at the backend
 * (`POST /api/staff-portal/assessments` requires `Assessment_Create`
 * and re-validates every id via StaffTeachingScopeService). No
 * client-side auth check needed here — the redirect target itself
 * gates the dialog on `canCreate("Assessment")`.
 */
const AssessmentCreate: React.FC = () => {
  const [searchParams] = useSearchParams();
  const params = new URLSearchParams();
  params.set("compose", "1");
  const studentId = searchParams.get("student_id");
  if (studentId) params.set("student_id", studentId);
  return <Navigate to={`/staff-portal/assessments?${params.toString()}`} replace />;
};

export default AssessmentCreate;
